import * as React from 'react';
import { Manager, Reference, Popper } from 'react-popper';
import './tooltip.scss';
export class Tooltip extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            show: false,
        };
        this.showTooltip = () => this.setState({ show: true });
        this.hideTooltip = () => this.setState({ show: false });
    }
    render() {
        return (React.createElement(Manager, null,
            React.createElement("div", { className: "members-badges-lib-tooltip-style-wrapper" },
                React.createElement(Reference, null, ({ ref }) => (React.createElement("div", { style: { position: 'relative' }, onMouseEnter: this.showTooltip, onMouseLeave: this.hideTooltip, ref: ref }, this.props.children))),
                React.createElement(Popper, { placement: "top", strategy: "fixed" }, ({ ref, style, placement }) => this.state.show && (React.createElement("div", { className: "tooltip-wrapper", ref: ref, style: style, "data-placement": placement }, this.props.message))))));
    }
}
//# sourceMappingURL=Tooltip.js.map